<div class="landing" [style.--landing-accent-color]="config.general?.background_color">
  <app-landing-hero [config]="config"></app-landing-hero>

  <main class="landing-body">
    <!-- Una pestaña por sección (se muestra aunque haya una sola) -->
    <nav class="landing-tabs" *ngIf="sections.length">
      <button
        type="button"
        class="landing-tab"
        *ngFor="let section of sections; let i = index"
        [class.active]="i === selectedSection"
        (click)="selectedSection = i"
      >
        <span class="material-icons" *ngIf="isIconName(section.icon)">{{ section.icon }}</span>
        {{ section.name }}
      </button>
    </nav>

    <section class="landing-section">
      <div class="landing-cards">
        <app-landing-compact-card
          *ngFor="let form of forms"
          [form]="form"
          (open)="selectForm.emit(form)"
        ></app-landing-compact-card>
      </div>
    </section>
  </main>
</div>
